import React, { Component } from 'react';
import { connect } from 'react-redux';
import './visitor.scss';
import {
  getVisitorsEs
} from '../../ducks/visitor';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import ContentLoader from 'react-content-loader';
import { NoDataImg } from '../../img';

const moment = require('moment');
let b = {};
// let arrChips = [];
// let objQ = {};
let pg = 2;

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <ContentLoader
      height={40}
      width={1060}
      speed={2}
      primaryColor="#eceef4"
      secondaryColor="#fff"
      {...props}
    >
      <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4" />
      <rect x="25" y="13" rx="6" ry="6" width={70 * random} height="12" />
      <rect x="114" y="13" rx="6" ry="6" width={135 * random} height="12" />
      <rect x="265" y="13" rx="6" ry="6" width={70 * random} height="12" />
      <rect x="365" y="13" rx="6" ry="6" width={140 * random} height="12" />
      <rect x="524" y="13" rx="6" ry="6" width={110 * random} height="12" />
      <rect x="660" y="13" rx="6" ry="6" width={140 * random} height="12" />
      <rect x="820" y="13" rx="6" ry="6" width={120 * random} height="12" />
      <rect x="975" y="13" rx="6" ry="6" width="50" height="12" />
      <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3" />
    </ContentLoader>
  );
};

class Visitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeVistPage: 1,
      activeVistHistPage: 1,
      seVisHist: '',
      tabIndex: 0,
      sd: new Date(),
      ed: '',
      eu: '',
      isShow: false,
      isSer: false,
      chipsArr: [],
      items: [],
      hasMore: true,
      noData: false,
      isLoding: false,
      pgForDupl: 0,
      mData: [],
      pos: 0,
      isPag: true,
      isLod: true,
      cou: 0,
      co: 0,
      isDis: false,
      histLoad: true,
      cn: '',
      isShowLoadMore: false,
      widgetList: []
    };
  }

  componentDidMount() {
    pg = 1;
    this.state.items = [];
    this.setState(this.state);

    if (document.getElementById('add_wall_btn'))
      document.getElementById('add_wall_btn').style.display = 'flex';

    if (document.getElementById('sidebarlink_1'))
      document.getElementById('sidebarlink_1').classList.remove('side-active');

    if (this.props.location.query && this.props.location.query.fil) {
      let { fil, fm, to } = this.props.location.query;
      b = {};
      if (fil == 'today') { b = { pn: 1, ps: 10, td: { fm: new Date().setHours(0, 0, 0, 0), to: new Date().setHours(24, 0, 0, 0) } }; }
      else if (fil == 'week') {
        b = { pn: 1, ps: 10, wd: { fm: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0), to: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 59) } };
        this.setState({ activeVistPage: 1, tabIndex: 1, seVisHist: '' });
      }
      else if (fil == 'month') {
        b = { pn: 1, ps: 10, md: { fm: new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(0, 0, 0, 0), to: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 59) } };
        this.setState({ activeVistPage: 1, tabIndex: 2, seVisHist: '' });
      }
      else if (fil == 'custom') {
        if (fm && to) {
          b = { pn: 1, ps: 10, sd: parseInt(fm), ed: parseInt(to) };
          this.setState({ activeVistPage: 1, tabIndex: 3, seVisHist: '' });
        }
      }
    }
    else { b = { pn: 1, ps: 10, td: { fm: new Date().setHours(0, 0, 0, 0), to: new Date().setHours(24, 0, 0, 0) } }; }
    this.props.getVisitorsEs(b);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visitors !== this.props.visitors) {
      this.state.isDis = false;
      this.state.isShowLoadMore = true;
      let { visitors } = this.props;
      if (visitors && visitors.count) {
        this.state.cou = visitors.count;
        this.setState(this.state);
      }
      if (visitors && visitors.data && visitors.data.length === 0) {
        this.state.noData = false;
        this.state.hasMore = false;
        this.state.isLod = false;
        this.setState(this.state);
      }
      else if (visitors && visitors.data && visitors.data.length > 0) {
        if (visitors.data.length < 10) {
          this.state.items = [...this.state.items, ...visitors.data];
          this.state.hasMore = false;
        }
        else {
          this.state.co = this.state.co + 10;
          this.state.items = [...this.state.items, ...visitors.data];
          this.state.hasMore = true;
        }
        this.state.noData = false;
        this.state.isLod = false;
        this.setState(this.state);
      }
      if (visitors.widget && visitors.widget.length > 0) {
        this.state.widgetList = visitors.widget;
        this.setState(this.state);
      }
    }
    if (prevProps.visitHistory != this.props.visitHistory) {
      this.state.histLoad = false;
      this.setState(this.state);
    }
  }

  getVisitorsEs = (pn, tbi) => {
    b = {};
    this.state.activeVistPage = pn; this.state.tabIndex = tbi; this.state.hasMore = true; this.state.isPag = true; this.state.seVisHist = '';
    this.setState(this.state);
    if (pn === 1) {
      this.state.isLod = true; this.setState(this.state); pg = 1; this.removeData();
    }
    if (pg === 1) { this.state.co = 0; this.state.isLod = true; this.setState(this.state); pg = 1; this.removeData(); }

    b = { pn: pg, ps: 10 };
    delete b['eu'];

    if (this.state.eu) { b['eu'] = this.state.eu; }
    if (this.state.cn) { b['cn'] = this.state.cn; }
    if (tbi == 0) { let x = new Date(); b['td'] = { fm: x.setHours(0, 0, 0, 0), to: x.setHours(24, 0, 0, 0) }; }
    else if (tbi == 1) {
      b['wd'] = {
        fm: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0), to: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 59)
      };
    }
    else if (tbi == 2) {
      b['md'] = {
        fm: new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(0, 0, 0, 0), to: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 59)
      };
    }
    // this.props.getVisitors(b);
    this.props.getVisitorsEs(b);
  }

  getPaging = (pn) => {
    pg = pn + 1;
    this.state.isShowLoadMore = false;
    if (this.state.tabIndex == 3) {
      this.state.activeVistPage = pg; this.state.hasMore = true; this.state.isPag = true;
      b.pn = pg;
      // this.props.getVisitors(b);
      this.props.getVisitorsEs(b);
    }
    else {
      this.getVisitorsEs(pg, this.state.tabIndex);
    }
    this.setState(this.state);
  }

  getWidgetName = (wdgtid) => {
    let _i = this.state.widgetList.findIndex(x => x._id.toString() == wdgtid.toString());
    if (_i !== -1)
      return this.state.widgetList[_i].wdsc;
    else
      return '-';
  }

  renderVisitorData = () => {
    let { items } = this.state;
    return <div className="visitor-data-content table-responsive">
      <table className="table tbl-middle-text tbl-header-bg  tbl-visitor" >
        <thead className="thead-light">
          <tr>
            <th className="tbl-no-col">No.</th>
            <th>Lead</th>
            <th>Hostname</th>
            <th>Widget Name</th>
            <th className="">Location</th>
            <th className="td-15x">Date</th>
          </tr>
        </thead>
        <tbody>
          {this.state.isLod == true ?
            <tr>
              <td colSpan="10">
                {Array(10)
                  .fill('')
                  .map((e, i) => (
                    <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                  ))}
              </td>
            </tr>
            :
            items && items.length > 0 ?
              items.map((obj, i) => {
                let { ct, cn, st } = obj;
                let loc = '';
                if (ct && st && cn) { loc = ct + ',' + ' ' + st + ',' + ' ' + cn; }
                else if (!ct && st && cn) { loc = st + ',' + ' ' + cn; }
                else if (ct && !st && cn) { loc = ct + ',' + ' ' + cn; }
                else if (ct && st && !cn) { loc = ct + ',' + ' ' + st; }
                obj['loc'] = loc;
                return (
                  <tr key={i}>
                    <td>{(i + 1)}</td>
                    <td>{(!obj.un || obj.un == ' ') ? obj.vid : obj.un}</td>
                    <td><a className="text-primary tbl-link-tewoline" style={{ textDecoration: 'none' }} href={obj.hrf} target="_blank">{obj.hrf}</a></td>
                    <td className=" ">{this.getWidgetName(obj.wdgtid)}</td>
                    <td className=" ">{obj.loc ? obj.loc : '-'}</td>
                    <td className=" ">{days_between(obj.upddt)}</td>
                  </tr>);
              })
              :
              items && items.length == 0 &&
              <tr>
                <td colSpan="6" className="text-center">
                  <div className="clearfix"></div>
                  <div className="nodata-block">
                    <div className="nodata-box">
                      <img src={NoDataImg} alt="No data" />
                      <h4>It looks like there are no visitors.</h4>
                      <p>To see how website visitors engage with notifications, make sure your site is getting visitors.</p>
                    </div>
                  </div>
                </td>
              </tr>
          }
          {this.state.hasMore == true && this.state.isLod == false && this.state.isShowLoadMore == true &&
            <tr>
              <td colSpan="10" style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.getPaging(pg)}>
                <a className="text-primary" style={{ textDecoration: 'none' }}> Load more</a>
              </td>
            </tr>
          }
          {this.state.isShowLoadMore == false &&
            <tr><td colSpan="10" style={{ textAlign: 'center' }}>Loading...</td></tr>
          }
        </tbody>
      </table >
    </div>;
  }

  removeData = () => {
    this.state.hasMore = true; this.state.items = []; pg = 1; this.setState(this.state);
  }

  searchByUn = (e) => {
    let code = e.keyCode || e.which;
    if (code == 13) {
      this.state.isDis = true;
      pg = 1;
      this.state.items = [];
      this.setState(this.state);
      this.getVisitorsEs(1, this.state.tabIndex);
    }
  }

  handleStateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (!e.target.value) {
      this.state.isDis = true;
      this.state.eu = '';
      this.state.cn = '';
      pg = 1;
      this.state.items = [];
      this.setState(this.state);
      this.getVisitorsEs(1, this.state.tabIndex);
    }
  }

  render() {
    const { isShow } = this.state;
    return (
      <div className='main-visitor '>
        <div className="visitor-container">
          <div className='header-breadcrumb'>
            <div className='header-breadcrumb-left'>
              <div class="header-breadcrumb-item breadcrumb-active">Visitors</div>
              {/* <div class="header-breadcrumb-item ">Visitors</div> */}
            </div>
          </div>
          <div className="visitor-content wdgt-main-cnt">
            <div className="">
              {!isShow &&
                <div className="">
                  <div className="page-content-topbar analytic-topbar visitor-topbar">
                    <div className="topbar-left">
                      <div className="tab-same tab-analytic-block">
                        <ul className="tab-same-list tab-analytic-list">
                          <li className={this.state.tabIndex === 0 ? 'active' : ''} onClick={() => this.getVisitorsEs(1, 0)}>Today</li>
                          <li className={this.state.tabIndex === 1 ? 'active' : ''} onClick={() => this.getVisitorsEs(1, 1)}>Last 7 days</li>
                          <li className={this.state.tabIndex === 2 ? 'active' : ''} onClick={() => this.getVisitorsEs(1, 2)}>Last 30 days</li>
                          <li className={this.state.tabIndex === 3 ? 'active' : ''}>
                            <DateRangePicker onEvent={this.handleEvent} maxDate={moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('MM-DD-YYYY')}>
                              Custom Date
                            </DateRangePicker>
                          </li>
                          <li className="visitor-topbar-fltserchinp">
                            {!isShow && <input type="text" className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-mainvisitor" name="eu" value={this.state.eu} placeholder="Search by Email, Username and Hostname" onKeyPress={(e) => this.searchByUn(e)} onChange={(e) => this.handleStateChange(e)} disabled={this.state.isDis} />}
                            {!isShow && <input type="text" className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-mainvisitor" name="cn" value={this.state.cn} placeholder="Search by Country" onKeyPress={(e) => this.searchByUn(e)} onChange={(e) => this.handleStateChange(e)} disabled={this.state.isDis} />}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <div>
                    <div className="analytic-data-content">
                      {this.renderVisitorData()}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const days_between = (date) => {
  if (new Date() >= new Date(date)) {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) { return interval + ' years ago'; }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) { return interval + ' months ago'; }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) { return interval + ' days ago'; }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) { return interval + ' hours ago'; }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) { return interval + ' minutes ago'; }
    return Math.floor(seconds) + ' seconds ago';
  }
  else { return 'live'; }
};

const mapStateToProps = state => ({
  // loading: state.getIn(['loading', 'state']),
  visitors: state.getIn(['visitor', 'visitors']),
  profile: state.getIn(['auth', 'profile'])
});


const mapDispatchToProps = {
  getVisitorsEs
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Visitor);


// WEBPACK FOOTER //
// ./src/containers/Visitor/Visitor.js